import { Plugin } from 'ckeditor5';

export default class MergeTagsEditing extends Plugin {
    init() {
    }
}
